import { Update } from "@ngrx/entity";
import { createAction, props } from "@ngrx/store";
import { Circulation } from "src/app/interfaces";

/*
export const loadCirculations = createAction(
  "[Circulation] Load Circulations",
  props<{ circulations: Circulation[] }>()
);
*/

export const addCirculation = createAction(
  "[Circulation] Add Circulation",
  props<{ circulation: Circulation }>()
);

export const upsertCirculation = createAction(
  "[Circulation] Upsert Circulation",
  props<{ circulation: Circulation }>()
);

export const addCirculations = createAction(
  "[Circulation] Add Circulations",
  props<{ circulations: Circulation[] }>()
);

export const upsertCirculations = createAction(
  "[Circulation] Upsert Circulations",
  props<{ circulations: Circulation[] }>()
);

export const updateCirculation = createAction(
  "[Circulation] Update Circulation",
  props<{ circulation: Update<Circulation> }>()
);

export const updateCirculations = createAction(
  "[Circulation] Update Circulations",
  props<{ circulations: Update<Circulation>[] }>()
);

export const deleteCirculation = createAction(
  "[Circulation] Delete Circulation",
  props<{ id: string }>()
);

export const deleteCirculations = createAction(
  "[Circulation] Delete Circulations",
  props<{ ids: string[] }>()
);

export const clearCirculations = createAction(
  "[Circulation] Clear Circulations"
);
